import styled from 'styled-components'

const Dot = styled.div`
  width: 16px;
  height: 16px;
  margin-left: -8px;
  margin-top: -8px;

  border: 3px solid white;
  border-radius: 50%;

  background-color: ${({ theme }) => theme.brand.sky};
  box-shadow: 0 0 0 6px rgba(151, 178, 218, 0.35);
`

type CurrentLocationMarkerProps = {
  /* Consumed by google-map-react to position the marker */
  lat: number
  lng: number
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CurrentLocationMarker = (_props: CurrentLocationMarkerProps) => (
  <Dot aria-label="Your location" role="img" />
)

export default CurrentLocationMarker
